/*
* tab
*/
export default class PageLoading {
  constructor() {
    this.$targetButton = document.querySelectorAll('[data-button="pageLoading"]');
  }

  attachEvent() {
    Array.prototype.forEach.call( this.$targetButton, $button => {
      $button.addEventListener('click', () => {
        document.body.insertAdjacentHTML('beforeend',
          `<div class="loader-page__wrap">
            <div class="loader-page"></div>
          </div>`);
      });
    });
  }
}
